import { render, staticRenderFns } from "./AppCard.vue?vue&type=template&id=328b1a9e&scoped=true&"
import script from "./AppCard.vue?vue&type=script&lang=ts&"
export * from "./AppCard.vue?vue&type=script&lang=ts&"
import style0 from "./AppCard.vue?vue&type=style&index=0&id=328b1a9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328b1a9e",
  null
  
)

export default component.exports